const IDLE_TIMEOUT = 2000;
const OBSERVER_MARGIN = '400px';

/**
 * Kontekst żądania złożony z atrybutów data- znacznika skryptu.
 *
 * Backend nie emituje żadnego inline JS - wszystko, co moduł musi wiedzieć o stronie, jedzie
 * w atrybutach, więc strona pozostaje zgodna z restrykcyjnym CSP.
 */
function createContext(script) {
    const data = script && script.dataset ? script.dataset : {};

    return {
        base: data.base || '/',
        data: data,
        int: function (key) {
            return parseInt(data[key], 10) || 0;
        }
    };
}

function whenIdle(callback) {
    if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(callback, { timeout: IDLE_TIMEOUT });
        return;
    }
    window.setTimeout(callback, 1);
}

function whenVisible(element, callback) {
    if (typeof window.IntersectionObserver !== 'function') {
        callback();
        return;
    }
    const observer = new window.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
                return;
            }
            observer.unobserve(entry.target);
            callback();
        });
    }, { rootMargin: OBSERVER_MARGIN });
    observer.observe(element);
}

function logFailure(name, error) {
    if (window.console && typeof window.console.error === 'function') {
        window.console.error('[front] moduł ' + name, error);
    }
}

/**
 * Chunk modułu pobierany jest dopiero tutaj. Webpack zapamiętuje obietnicę, więc powtórne
 * wywołanie dla drugiego elementu nie generuje kolejnego żądania sieciowego.
 */
function start(entry, context, element) {
    entry.load()
        .then(function (module) {
            (module.default || module)(context, element);
        })
        .catch(function (error) {
            logFailure(entry.name, error);
        });
}

/**
 * Dwie niezależne przesłanki wejścia modułu, obie mogą zajść na jednej stronie:
 * `immediate` - moduł ma coś do zrobienia niezależnie od widoku (np. zapis historii),
 * `observe`   - moduł obsługuje konkretny element i wchodzi dopiero, gdy ten zbliża się do
 *               viewportu. Element, którego gość nigdy nie zobaczy, nie kosztuje ani jednego
 *               żądania - ani po chunk, ani po treść.
 */
function mount(entry, context) {
    if (entry.immediate && entry.immediate(context)) {
        whenIdle(function () {
            start(entry, context, null);
        });
    }
    if (!entry.observe) {
        return;
    }
    Array.prototype.forEach.call(document.querySelectorAll(entry.observe), function (element) {
        whenVisible(element, function () {
            start(entry, context, element);
        });
    });
}

export default function run(registry, script) {
    const node = script || document.querySelector('script[data-selly-front]');
    const context = createContext(node);

    registry.forEach(function (entry) {
        try {
            mount(entry, context);
        } catch (error) {
            logFailure(entry.name, error);
        }
    });
}
